import { runImpactCalculateTourCo2ForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-co2-for-project.action';
import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourEvent } from '../entities/project-tour-ontour-event.entity';
import { getTourEvents } from './get-tour-events.action';

export type BulkAddTourEvent = Params;

type Params = {
  sequenceId: number;
  tourEvents: Pick<
    TourEvent,
    'name' | 'date' | 'position' | 'capacity' | 'type'
  >[];
};

type Result = void;

export const bulkAddTourEvent = createAppAsyncThunk(
  'projectTourOntour/bulkAddTourEvent',
  async (
    params: Params,
    {
      extra: { projectTourOntourGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      await projectTourOntourGateway.bulkAddEvents(
        params.sequenceId,
        params.tourEvents,
      );
      await dispatch(getTourEvents({ sequenceId: params.sequenceId }));
      const projectId = selectCurrentProjectTour(getState())?.id || -1;
      await dispatch(runImpactCalculateTourCo2ForProject({ projectId }));
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('AddTourEvents.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('AddTourEvents.Message.error'));
}
